import { forwardRef } from 'react';
import { CrudTableTestSubject } from '@logz-pkg/enums';
import { Button } from '../../Button/Button.component';
import { IAddButtonProps } from './Crud.types';
import { useAddRecordButton } from './add-record-button.hook';

export const AddRecordButton = forwardRef<HTMLButtonElement, IAddButtonProps>(
  (
    {
      disabled = false,
      tableSubject,
      addButtonText = 'Add record',
      disabledTooltip,
      tooltipPlacement = 'bottom',
      CustomAddButton,
    },
    ref,
  ) => {
    const { handleClick, isDisabled } = useAddRecordButton({ disabled });

    const subject = tableSubject
      ? `${tableSubject}-${CrudTableTestSubject.TableAddButton}`
      : CrudTableTestSubject.TableAddButton;

    return CustomAddButton ? (
      <CustomAddButton
        ref={ref}
        onClick={handleClick}
        icon={'plus-regular'}
        disabled={isDisabled}
        subject={subject}
        disabledTooltip={disabledTooltip}
        tooltipPlacement={tooltipPlacement}
      >
        {addButtonText}
      </CustomAddButton>
    ) : (
      <Button
        ref={ref}
        onClick={handleClick}
        icon={'plus-regular'}
        disabled={isDisabled}
        subject={subject}
        disabledTooltip={disabledTooltip}
        tooltipPlacement={tooltipPlacement}
      >
        {addButtonText}
      </Button>
    );
  },
);

AddRecordButton.displayName = 'AddRecordButton';
